import { render, staticRenderFns } from "./wishlist-multiple.vue?vue&type=template&id=2bb8b27d&scoped=true"
import script from "./wishlist-multiple.vue?vue&type=script&lang=js"
export * from "./wishlist-multiple.vue?vue&type=script&lang=js"
import style0 from "./wishlist-multiple.vue?vue&type=style&index=0&id=2bb8b27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8b27d",
  null
  
)

export default component.exports